import {
  cmsApiOnReturnDateChangeSelector,
  dateLabelSelector,
  returnDateTimestampSelector,
} from '../../selectors';
import { ThunkType } from 'app/hooks/appHooks';
import { toggleReturnDate } from 'app/store/reducers/date';
import { fromUnixTime } from 'date-fns';

export const hideReturnDate = (): ThunkType<void> => {
  return (dispatch, getState) => {
    const state = getState();

    const returnDateTimeStamp = returnDateTimestampSelector(state);
    const onReturnDateChanged = cmsApiOnReturnDateChangeSelector(state);
    const dateLabel = dateLabelSelector(state);

    const dateLocalized = dateLabel(fromUnixTime(returnDateTimeStamp));
    const payload = {
      date: returnDateTimeStamp,
      dateLocalized,
    };

    onReturnDateChanged(payload);

    dispatch(toggleReturnDate({ isVisible: false }));
  };
};
